import DetailsLeftPart from '../../components/DetailsPageComponent/DetailsLeftPart/DetailsLeftPart';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(DetailsLeftPart);
